import { useState, useEffect } from "react";
import { saveAs } from "file-saver";

const API_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_API_URL_DEV
    : process.env.REACT_APP_API_URL_PRO;

export default function DashboardPage() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterType, setFilterType] = useState("Screener Qualified");
  const [qualifiedUsers, setQualifiedUsers] = useState(0);
  const [surveyInvitations, setSurveyInvitations] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMetrics = () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (filterType) params.append("type", filterType);

    fetch(`${API_URL}/api/dashboard/metrics?${params.toString()}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch metrics");
        return res.json();
      })
      .then((data) => {
        setQualifiedUsers(data.qualifiedUsers || 0);
        setSurveyInvitations(data.surveyInvitations || 0);
        setError(null);
      })
      .catch((err) => {
        console.error("Error fetching metrics:", err);
        setError("Failed to load metrics");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchMetrics(); // initial load
  }, []);

  const exportToCSV = () => {
    const query = new URLSearchParams({
      startDate,
      endDate,
      filterType,
    });

    fetch(`${API_URL}/api/dashboard/export?${query.toString()}`)
      .then(async (res) => {
        if (!res.ok) {
          const errorText = await res.text();
          let message = "Failed to export data";

          try {
            const errJson = JSON.parse(errorText);
            message = errJson.message || errJson.error || message;
          } catch {
            message = errorText || message;
          }

          if (res.status === 404) {
            alert("No data found to export");
          } else if (res.status === 500) {
            alert("Failed to export CSV (server error)");
          } else {
            alert(message);
          }

          throw new Error(message);
        }

        return res.blob();
      })
      .then((blob) => {
        const today = new Date().toISOString().split("T")[0];
        const filename =
          startDate && endDate
            ? `dashboard_export_${startDate}_to_${endDate}.csv`
            : `dashboard_export_${today}.csv`;

        saveAs(blob, filename);
      })
      .catch((err) => {
        console.error("Error exporting CSV:", err);
      });
  };

  return (
    <div className="container py-4">
      {/* Date Range & Filter */}
      <div className="row mb-4">
        <div className="col-md-3">
          <label className="form-label">Start Date</label>
          <input
            type="date"
            className="form-control"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">End Date</label>
          <input
            type="date"
            className="form-control"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Data Type</label>
          <select
            className="form-select"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option>Screener Qualified</option>
            <option>Survey Invite</option>
          </select>
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button className="btn btn-primary w-100" onClick={fetchMetrics}>
            Apply
          </button>
        </div>
      </div>

      {/* Metrics */}
      <div className="row mb-4">
        <div className="col-md-6">
          <div className="card shadow-sm rounded-3 text-center p-3">
            <h5>Qualified Users</h5>
            <p className="display-6 fw-bold">
              {loading ? "..." : error ? "-" : qualifiedUsers}
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card shadow-sm rounded-3 text-center p-3">
            <h5>Survey Invitations</h5>
            <p className="display-6 fw-bold">
              {loading ? "..." : error ? "-" : surveyInvitations}
            </p>
          </div>
        </div>
      </div>

      {/* Export */}
      <div className="d-flex justify-content-end">
        <button className="btn btn-success text-nowrap" onClick={exportToCSV}>
          Export CSV
        </button>
      </div>
    </div>
  );
}
